import { createStore } from 'vuex'

export default createStore({
  state: {
    dictionary: {},
    areaTree: [],
    userInfo: { name: '管理员' },
    role: '',
    menu: [
      { path: '/dashboard', name: '工作台', meta: { title: '工作台', icon: 'ele-Odometer' } },
      { path: '/expert', name: '专家信息管理', meta: { title: '专家信息管理', icon: 'ele-User' } },
      { path: '/expertAudit', name: '专家审核', meta: { title: '专家审核', icon: 'ele-EditPen' } },
      { path: '/reviewRecord', name: '评审记录', meta: { title: '评审记录', icon: 'ele-Document' } },
      { path: '/evaluation', name: '评价管理', meta: { title: '评价管理', icon: 'ele-Star' } },
      { path: '/expertTag', name: '专家标签维护', meta: { title: '专家标签维护', icon: 'ele-PriceTag' } }
    ]
  },
  getters: {
  },
  mutations: {
    setDictionary(state, data) {
      state.dictionary = data;
    },
    setAreaTree(state, data) {
      state.areaTree = data;
    },
    setUserInfo(state, data) {
      state.userInfo = data;
    },
    setRole(state, data) {
      state.role = data;
    },
    setMenu(state, data) {
      state.menu = data;
    }
  },
  actions: {
  },
  modules: {
  }
})
